import { MapPin } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import { useSectionNav } from "@/hooks/useSectionNav";

const AREAS = [
  { name: "Gap, Pennsylvania", tag: "Home Base", primary: true },
  { name: "Lancaster County", tag: "Surrounding Areas" },
  { name: "Chester County", tag: "Surrounding Areas" },
];

const ServiceArea = () => {
  const go = useSectionNav();
  return (
    <section id="service-area" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="service-area-section">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <SectionHeading
            index="05"
            eyebrow="Service Area"
            title="Proudly Serving Our Local Area"
            sub="Mobile auto detailing based in Gap, PA — regularly serving Paradise, Parkesburg, and surrounding communities across Lancaster and Chester Counties. If you're close by, there's a good chance we can get to you."
          />
          <Reveal delay={0.15}>
            <p className="text-base leading-relaxed text-slate-300">
              Not sure if you're within our service area? Send us your location and we'll let you know.
            </p>
            <button onClick={() => go("quote")} className="btn-primary mt-7" data-testid="check-location-button">
              Check Your Location
            </button>
          </Reveal>
        </div>
        <div className="flex flex-col justify-center gap-4">
          {AREAS.map((area, i) => (
            <Reveal key={area.name} delay={i * 0.1} y={24}>
              <div
                className={`flex items-center justify-between border p-6 sm:p-7 ${
                  area.primary ? "border-blue-500/50 bg-navy/20" : "border-white/10 bg-surface"
                }`}
                data-testid={`area-card-${i}`}
              >
                <div className="flex items-center gap-4">
                  <MapPin size={22} strokeWidth={1.8} className={area.primary ? "text-blue-400" : "text-slate-500"} aria-hidden="true" />
                  <p className="font-display text-xl font-bold uppercase tracking-wide text-white sm:text-2xl">{area.name}</p>
                </div>
                <span className={`font-mono text-[10px] font-semibold uppercase tracking-[0.2em] ${area.primary ? "text-blue-400" : "text-slate-500"}`}>
                  {area.tag}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;
